import { Box, Typography } from '@mui/material';
import { normalizeJudgement } from '@/components/review/consensus';
import { formatDecisionSummary, getJudgementLabel, getJudgementTextColor, type JudgementOption } from '@/types';

function judgementToApiValue(value?: string | null): JudgementOption | null {
  const normalized = normalizeJudgement(value);
  if (normalized === 'correct') return 'correct';
  if (normalized === 'incorrect') return 'wrong';
  if (normalized === 'uncertain') return 'uncertain';
  return null;
}

interface Props {
  judgement?: string | null;
  reviewedDecision?: string | null;
  reviewedPunishment?: string | null;
  dark?: boolean;
  prefix?: string;
  variant?: 'caption' | 'body2';
  sx?: object;
}

export default function JudgementOutcomeLine({
  judgement,
  reviewedDecision,
  reviewedPunishment,
  dark = false,
  prefix,
  variant = 'caption',
  sx,
}: Props) {
  const apiValue = judgementToApiValue(judgement);
  if (!apiValue) return null;

  const label = getJudgementLabel(apiValue);
  const showReviewed = apiValue === 'wrong' || apiValue === 'uncertain';
  const reviewed = showReviewed
    ? formatDecisionSummary(reviewedDecision, reviewedPunishment)
    : null;
  const showArrow = !!reviewed && reviewed !== '—';

  return (
    <Typography
      variant={variant}
      sx={{
        display: 'block',
        color: dark ? 'rgba(255,255,255,0.85)' : 'text.secondary',
        ...sx,
      }}
    >
      {prefix}
      <Box component="span" sx={{ color: getJudgementTextColor(apiValue, dark), fontWeight: 700 }}>
        {label}
      </Box>
      {showArrow && <> → {reviewed}</>}
    </Typography>
  );
}
